import React, { createContext, useContext, useReducer } from 'react'

export const initState = {
  isLoad: false,
}

export const reducer = (state, action) => {
  switch (action.type) {
    case 'loaded':
      return {
        ...state,
        isLoad: action.payload,
      }
    case 'loading':
    case 'unloaded':
      return {
        ...state,
        isLoad: action.payload,
      }
    default:
      return {
        ...state,
        isLoad: action.payload,
      }
  }
}

export const viewerContext = createContext(initState)

export function ViewerProvider({ children, reducer }) {
  return <viewerContext.Provider value={reducer}>{children}</viewerContext.Provider>
}

export const useViewerReducer = (initContext) => useReducer(reducer, initContext || initState)
export const useViewerContext = () => useContext(viewerContext)
